import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../views/Layout.vue";
import { MessageBox } from "element-ui";
import store from "../store";
// import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Layout",
    redirect: "/index",
    component: Layout,
    children: [
      {
        path: "/index",
        name: "Index",
        meta: {
          routerName: {
            parentName: "首页",
            childName: ""
          }
        },
        component: () => import("../views/Home/Index.vue")
      },
      {
        path: "/report_progress",
        name: "ReportProgress",
        meta: {
          routerName: {
            parentName: "首页",
            childName: "报送详情"
          }
        },
        component: () =>
          import("../components/Home/ReportAssignmentsProgress.vue")
      },
      /**
       * 资产管理
       */
      {
        path: "/assets-debt",
        name: "AssetsDebt",
        meta: {
          routerName: {
            parentName: "资产管理",
            childName: "资产负债"
          }
        },
        component: () => import("../views/Assets/Debt.vue")
      },
      {
        path: "/unit-data-detail",
        name: "UnitDataDetail",
        meta: {
          routerName: {
            parentName: "档案查询",
            childName: "单位详情"
          }
        },
        component: () => import("../views/Other/UnitDataDetail")
      },

      {
        path: "/assets-incomeExpense",
        name: "AssetsIncomeExpense",
        meta: {
          routerName: {
            parentName: "资产管理",
            childName: "收支状况"
          }
        },
        component: () => import("../views/Assets/IncomeExpenses.vue")
      },

      {
        path: "/assets-management",
        name: "AssetsManagement",
        meta: {
          routerName: {
            parentName: "资产管理",
            childName: "经营状况"
          }
        },
        component: () => import("../views/Assets/Management.vue")
      },

      {
        path: "/assets-service",
        name: "AssetsService",
        meta: {
          routerName: {
            parentName: "资产管理",
            childName: "业务状况"
          }
        },
        component: () => import("../views/Assets/Service.vue")
      },

      {
        path: "/assets-personnel",
        name: "AssetsPersonnel",
        meta: {
          routerName: {
            parentName: "资产管理",
            childName: "人员状况"
          }
        },
        component: () => import("../views/Assets/Personnel.vue")
      },

      {
        path: "/assets-house",
        name: "AssetsHouse",
        meta: {
          routerName: {
            parentName: "资产管理",
            childName: "房屋土地"
          }
        },
        component: () => import("../views/Assets/House.vue")
      },

      {
        path: "/assets-house-change",
        name: "AssetsHouseChange",
        meta: {
          routerName: {
            parentName: "资产管理",
            childName: "房屋土地"
          }
        },
        component: () => import("../views/Assets/HouseChange.vue")
      },

      {
        path: "/assets-upload",
        name: "AssetsUpload",
        meta: {
          routerName: {
            parentName: "资产管理",
            childName: "材料上传"
          }
        },
        component: () => import("../views/Assets/Upload.vue")
      },

      /**
       * 上报审批
       */

      {
        path: "/approval-create",
        name: "ApprovalCreate",
        meta: {
          routerName: {
            parentName: "上报审批",
            childName: "生成报表"
          }
        },
        component: () => import("../views/Approval/Create.vue")
      },

      {
        path: "/approval-other",
        name: "ApprovalOther",
        meta: {
          routerName: {
            parentName: "上报审批",
            childName: "新增其他"
          }
        },
        component: () => import("../views/Approval/Other.vue")
      },

      {
        path: "/approval-other-detail",
        name: "ApprovalOtherDetail",
        meta: {
          routerName: {
            parentName: "上报审批",
            childName: "新增其他"
          }
        },
        component: () =>
          import("../components/BaseTableStaticDetail/Other/ApprovalOther.vue")
      },

      {
        path: "/approval-report",
        name: "ApprovalReport",
        meta: {
          routerName: {
            parentName: "上报审批",
            childName: "上报目录"
          }
        },
        component: () => import("../views/Approval/Report.vue")
      },

      {
        path: "/approval-approval",
        name: "ApprovalApproval",
        meta: {
          routerName: {
            parentName: "上报审批",
            childName: "审批目录"
          }
        },
        component: () => import("../views/Approval/Approval.vue")
      },

      {
        path: "/approval-assignments",
        name: "ApprovalAssignments",
        meta: {
          routerName: {
            parentName: "上报审批",
            childName: "我的上报任务"
          }
        },
        component: () => import("../views/Approval/MyAssignments.vue")
      },

      /**
       * 统计查询
       */
      {
        path: "/statistics-personalized",
        name: "StatisticsPersonalized",
        meta: {
          routerName: {
            parentName: "统计查询",
            childName: "个性化统计"
          }
        },
        component: () => import("../views/Statistics/Personalized.vue")
      },

      {
        path: "/statistics-query",
        name: "StatisticsQuery",
        meta: {
          routerName: {
            parentName: "统计查询",
            childName: "档案查询"
          }
        },
        component: () => import("../views/Statistics/Query.vue")
      },

      /**
       * 数据分析
       */

      {
        path: "/analysis-administration",
        name: "AnalysisAdministration",
        meta: {
          routerName: {
            parentName: "数据分析",
            childName: "资产数据"
          }
        },
        component: () => import("../views/Analysis/Administration.vue")
      },

      {
        path: "/analysis-career",
        name: "AnalysisCareer",
        meta: {
          routerName: {
            parentName: "数据分析",
            childName: "工人文化宫数据"
          }
        },
        component: () => import("../views/Analysis/Career.vue")
      },

      // {
      //   path: "/analysis-enterprising",
      //   name: "Enterprising",
      //   meta: {
      //     routerName: {
      //       parentName: "企业性资产",
      //       childName: "数据分析"
      //     }
      //   },
      //   component: () => import("../views/Analysis/Enterprising.vue")
      // },

      // {
      //   path: "/analysis-other",
      //   name: "EnterprisingOther",
      //   meta: {
      //     routerName: {
      //       parentName: "其他资产",
      //       childName: "数据分析"
      //     }
      //   },
      //   component: () => import("../views/Analysis/Other.vue")
      // },

      /**
       * 单位用户
       */

      {
        path: "/organization-information",
        name: "OrganizationInformation",
        meta: {
          routerName: {
            parentName: "单位用户",
            childName: "单位信息"
          }
        },
        component: () => import("../views/Organization/Information.vue")
      },

      {
        path: "/organization-userinfo",
        name: "OrganizationUserinfo",
        meta: {
          routerName: {
            parentName: "单位用户",
            childName: "个人信息"
          }
        },
        component: () => import("../views/Organization/Userinfo.vue")
      },

      {
        path: "/organization-structure",
        name: "OrganizationStructure",
        meta: {
          routerName: {
            parentName: "单位用户",
            childName: "单位层级"
          }
        },
        component: () => import("../views/Organization/Structure.vue")
      },

      {
        path: "/organization-units-list",
        name: "UnitsList",
        meta: {
          routerName: {
            parentName: "单位用户",
            childName: "单位列表"
          }
        },
        component: () => import("../views/Organization/UnitsLists.vue")
      },
      {
        path: "/organization-user",
        name: "OrganizationUser",
        meta: {
          routerName: {
            parentName: "单位用户",
            childName: "用户列表"
          }
        },
        component: () => import("../views/Organization/User.vue")
      },
      {
        path: "/organization-role",
        name: "OrganizationRole",
        meta: {
          routerName: {
            parentName: "系统管理",
            childName: "角色权限"
          }
        },
        component: () => import("../views/Organization/Role.vue")
      },
      {
        path: "/organization-properties",
        name: "OrganizationProperties",
        meta: {
          routerName: {
            parentName: "系统管理",
            childName: "单位性质"
          }
        },
        component: () => import("../views/Organization/Properties.vue")
      },
      {
        path: "/organization-updatelog",
        name: "UpdateLog",
        meta: {
          routerName: {
            parentName: "更新日志",
            childName: ""
          }
        },
        component: () => import("../views/Organization/UpdateLog.vue")
      },
      {
        path: "/organization-loglist",
        name: "LogList",
        meta: {
          routerName: {
            parentName: "超管权限",
            childName: "版本更新"
          }
        },
        component: () => import("../views/Organization/LogList.vue")
      },
      /**
       * 公告管理
       */

      {
        path: "/announce-list",
        name: "AnnounceList",
        meta: {
          routerName: {
            parentName: "公告管理",
            childName: "公告通知列表"
          }
        },
        component: () => import("../views/Announce/List.vue")
      },
      {
        path: "/announce-trend",
        name: "AnnounceTrend",
        meta: {
          routerName: {
            parentName: "公告管理",
            childName: "工会动态列表"
          }
        },
        component: () => import("../views/Announce/Trend.vue")
      },
      {
        path: "/announce-assets-notice",
        name: "AnnounceAssetsNotice",
        meta: {
          routerName: {
            parentName: "公告管理",
            childName: "资产通报列表"
          }
        },
        component: () => import("../views/Announce/AssetsNotice.vue")
      },

      {
        path: "/announce-publish",
        name: "AnnouncePublish",
        meta: {
          routerName: {
            parentName: "公告管理",
            childName: "发布公告"
          }
        },
        component: () => import("../views/Announce/Publish.vue")
      },

      {
        path: "/announce-category",
        name: "announceCategory",
        meta: {
          routerName: {
            parentName: "公告管理",
            childName: "公告分类"
          }
        },
        component: () => import("../views/Announce/Category.vue")
      },

      {
        path: "/announce-detail",
        name: "AnnounceDetail",
        meta: {
          routerName: {
            parentName: "公告管理",
            childName: "公告详情"
          }
        },
        component: () => import("../views/Announce/AnnounceDetail.vue")
      },

      /**
       * 留言管理
       */

      {
        path: "/leave-message",
        name: "LeaveMessage",
        meta: {
          routerName: {
            parentName: "留言管理",
            childName: "留言列表"
          }
        },
        component: () => import("../views/LeaveMessages/LeaveMessage.vue")
      },
      {
        path: "/leave-message-detail",
        name: "LeaveMessageDetail",
        meta: {
          routerName: {
            parentName: "留言管理",
            childName: "详情"
          }
        },
        component: () =>
          import("@/components/LeaveMessage/LeaveMessageDetail.vue")
      },

      /**
       * 使用指南
       */

      {
        path: "/use-guide",
        name: "UseGuide",
        meta: {
          routerName: {
            parentName: "使用指南"
          }
        },
        component: () => import("../views/Other/UseGuide.vue")
      },
      {
        path: "/assets-debt-detail",
        name: "AssetsDebtDetail",
        meta: {
          routerName: {
            parentName: "审批目录",
            childName: "详情"
          }
        },
        component: () => import("../views/Approval/AssetsDetail/Debt.vue")
      },
      {
        path: "/income-detail",
        name: "IncomeDetail",
        meta: {
          routerName: {
            parentName: "审批目录",
            childName: "详情"
          }
        },
        component: () =>
          import("../views/Approval/AssetsDetail/IncomeExpenses.vue")
      },
      {
        path: "/management-detail",
        name: "ManagementDetail",
        meta: {
          routerName: {
            parentName: "审批目录",
            childName: "详情"
          }
        },
        component: () =>
          import("../views/Approval/AssetsDetail/ManagementSituation.vue")
      },
      {
        path: "/personnel-detail",
        name: "PersonnelDetail",
        meta: {
          routerName: {
            parentName: "审批目录",
            childName: "详情"
          }
        },
        component: () =>
          import("../views/Approval/AssetsDetail/PersonalDetail.vue")
      },
      {
        path: "/server-detail",
        name: "ServerDetail",
        meta: {
          routerName: {
            parentName: "审批目录",
            childName: "详情"
          }
        },
        component: () =>
          import("../views/Approval/AssetsDetail/ServiceSituation.vue")
      },

      {
        path: "/house-land-detail",
        name: "houseAndLand",
        meta: {
          routerName: {
            parentName: "审批目录",
            childName: "详情"
          }
        },
        component: () => import("../views/Assets/HouseChange.vue")
      },

      {
        path: "/system-menu",
        name: "SystemMenu",
        meta: {
          routerName: {
            parentName: "系统管理",
            childName: "菜单管理"
          }
        },
        component: () => import("../views/System/Menu.vue")
      },

      {
        path: "/system-operation",
        name: "SystemOperation",
        meta: {
          routerName: {
            parentName: "系统管理",
            childName: "操作集"
          }
        },
        component: () => import("../views/System/Operation.vue")
      },
      {
        path: "/organization-edition",
        name: "OrganizationEdition",
        meta: {
          routerName: {
            parentName: "系统管理",
            childName: "测试环境设置"
          }
        },
        component: () => import("../views/Organization/Edition.vue")
      },
      {
        path: "/organization-guidetor",
        name: "OrganizationGuidetor",
        meta: {
          routerName: {
            parentName: "系统管理",
            childName: "使用指南编辑器"
          }
        },
        component: () => import("../views/Organization/Guidetor.vue")
      },
      {
        path: "/system-menu-permission",
        name: "SystemMenuPermission",
        meta: {
          routerName: {
            parentName: "系统管理",
            childName: "菜单权限"
          }
        },
        component: () => import("../views/System/MenuPermission.vue")
      },

      {
        path: "/report-form-assignments",
        name: "ReportFormAssignments",
        meta: {
          routerName: {
            parentName: "系统管理",
            childName: "填报配置"
          }
        },
        component: () => import("../views/System/ReportFormAssignments.vue")
      },

      {
        path: "/system-journal",
        name: "SystemJournal",
        meta: {
          routerName: {
            parentName: "系统管理",
            childName: "用户日志"
          }
        },
        component: () => import("../views/System/Journal.vue")
      },

      {
        path: "/404",
        name: "one404",
        meta: {
          routerName: {
            parentName: "404"
            // childName: "404"
          }
        },
        component: () => import("../views/Other/404.vue")
      }
    ]
  },

  {
    path: "*",
    name: "two404",
    redirect: "/404",
    meta: {
      routerName: {
        parentName: "404"
        // childName: "404"
      }
    },
    component: () => import("../views/Other/404.vue")
  },

  /**
   * 系统管理
   */

  {
    path: "/bi",
    name: "BI",
    meta: {
      routerName: {
        parentName: "BI",
        childName: ""
      }
    },
    component: () => import("../views/BI/index.vue")
  },
  {
    path: "/login",
    name: "Login",
    meta: {
      routerName: {
        parentName: "",
        childName: ""
      }
    },
    component: () => import("../views/Login/Login.vue")
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// token权限判断
router.beforeEach(async (to, from, next) => {
  if (to.path !== "/login") {
    if (localStorage.getItem("token")) {
      await store.dispatch("getUserInfo");

      await store.dispatch("getRolePermission");
      if (store.state.unitInfo.id) {
        if (!store.state.unitInfo.status && store.state.userInfo.id !== 0) {
          if (to.path === "/organization-information") {
            MessageBox.alert("请您先完善单位信息，即可使用本系统", "提示", {
              confirmButtonText: "确定",
              center: true
            });
            next();
          } else {
            MessageBox.alert("请您先完善单位信息，即可使用本系统", "提示", {
              confirmButtonText: "确定",
              center: true
            });
            next("/organization-information");
          }
        } else {
          next();
        }
      } else {
        let a = await store.dispatch("getUnitInfo");
        await store.dispatch("getAllOrg", {
          params: {
            org_id: store.state.unitInfo.id
          }
        });
        if (!a.status && store.state.userInfo.id !== 0) {
          if (to.path === "/organization-information") {
            MessageBox.alert("请您先完善单位信息，即可使用本系统", "提示", {
              confirmButtonText: "确定",
              center: true
            });
            next();
          } else {
            next("/organization-information");
          }
        } else {
          // 获取单位性质的目录
          let b = await store.dispatch("getCoType");
          if (a.father_property_type === -1) {
            store.commit("SET_MENU", b[3].menu_ids);
          } else {
            let c = b.find(o => {
              return o.id === a.father_property_type;
            });

            let d = c.child.find(o => {
              return o.id === a["property_type"];
            });

            store.commit("SET_MENU", d.menu_ids);
          }

          next();
        }
      }

      // if (userInfo.id === 0) {
      //   next()
      // } else {
      //   if (store.state.unitInfo.id) {
      //     if (!store.state.unitInfo.status) {
      //       if (to.path === "/organization-information") {
      //         MessageBox.alert('请您先完善单位信息，即可使用本系统', '提示', {
      //           confirmButtonText: '确定',
      //           center: true
      //         })
      //         next();
      //       } else {
      //         MessageBox.alert('请您先完善单位信息，即可使用本系统', '提示', {
      //           confirmButtonText: '确定',
      //           center: true
      //         })
      //         next("/organization-information");
      //       }
      //     } else {
      //       next();
      //     }
      //   } else {
      //     let a = await store.dispatch("getUnitInfo");
      //     await store.dispatch("getAllOrg", {
      //       params: {
      //         org_id: store.state.unitInfo.id
      //       }
      //     })
      //     if (!a.status) {
      //       if (to.path === "/organization-information") {
      //         MessageBox.alert('请您先完善单位信息，即可使用本系统', '提示', {
      //           confirmButtonText: '确定',
      //           center: true
      //         })
      //         next();
      //       } else {
      //         next("/organization-information");
      //       }
      //     } else {
      //       // 获取单位性质的目录
      //       let b = await store.dispatch("getCoType");
      //       if (a.father_property_type === -1) {
      //         store.commit("SET_MENU", b[3].menu_ids);
      //       } else {
      //         let c = b.find(o => {
      //           return o.id === a.father_property_type;
      //         });

      //         let d = c.child.find(o => {
      //           return o.id === a["property_type"];
      //         });

      //         store.commit("SET_MENU", d.menu_ids);
      //       }

      //       next();
      //     }
      //   }
      // }
    } else {
      next(`/login`);
    }
  } else {
    if (localStorage.getItem("token")) {
      next("/");
    }
    next();
  }
});

export default router;
